/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import React, {useState} from 'react';
import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/styles';


const SearchBarContainer = ({ inputColor,fill,background, placeholder, value, onSearch }) => {
    const theme = useTheme();
    const [searchQuery, setSearchQuery] = useState("");
    const handleChange = (e) => {
        setSearchQuery(e.target.value);
        onSearch(e.target.value);
    };

    return (
        <Box >
            <TextField
                variant="outlined"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleChange}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <SearchIcon sx={{
                        fontSize: '18px'
                    }} />
                    </InputAdornment>
                ),
                sx: {
                    backgroundColor: theme?.palette?.tertiary.main,
                    borderColor: theme?.palette?.border.color,
                    borderRadius: 2,
                    "& input::placeholder": {
                    fontSize: "12px", 
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '8px 14px',
                        borderColor: theme?.palette?.border.color,
                        paddingLeft: '0px',  
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme?.palette?.border.color,  
                        borderWidth: "1px",  
                    },
                }
                }}
                sx={{
                    // padding: '6px 8px',
                    boxSizing: 'border-box',
                    width: '300px'
                }}
            />
        </Box>

    )
};


export default SearchBarContainer;
